import { render, staticRenderFns } from "./morePicture.vue?vue&type=template&id=89e78c6a&"
import script from "./morePicture.vue?vue&type=script&lang=js&"
export * from "./morePicture.vue?vue&type=script&lang=js&"
import style0 from "./morePicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports